<template>
    <section>
        <router-link
                v-if="isEditable && $_updateActionAllowed"
                class="tab_button tab_button_add" :title="'Přidat obsah' | translate"
                :to="{ name: 'contentSourceContentNew', params: {id: contentSourceId} }">
        </router-link>
        <div class="status no_add">
            <h2 v-translate>Poskytované kanály</h2>
            <search-input input-class="search clearable" :show-label="false" v-model="search" @input="saveFilterValues"></search-input>
        </div>
        <div class="table_overflow">
          <table class="vypis vypis_detail" ref="table_with_action_line">
            <thead class="no_sortable">
            <tr>
                <th class="no_padding drag_drop"></th>
                <th class="no_padding checkbox"></th>
                <th class="channel"><span class="name" v-translate>Kanál</span></th>
                <th><span>ID</span></th>
                <th><span>ID EPG</span></th>
                <th v-for="linearTitle in linearTitles">
                    <span class="name">
                        {{ linearTitle }}
                        <span class="linear" :title="'Lineární' | translate" v-translate>Lineární</span>
                    </span>
                </th>
                <th v-for="nonlinearTitle in nonlinearTitles">
                    <span class="name">
                        {{ nonlinearTitle }}
                        <span class="nonlinear" :title="'Nelineární' | translate" v-translate>Nelineární</span>
                    </span>
                </th>
                <template v-if="nonlinearProtocolIds">
                    <th><span class="name" v-translate>TimeShift</span></th>
                    <th><span class="name" v-translate>CatchUp</span></th>
                    <th><span class="name" v-translate>PVR</span></th>
                </template>
                <th class="no_padding edit"></th>
            </tr>
            </thead>
            <content-source-content-row
                    v-for="content in entitiesPaginated"
                    :item="content"
                    :key="content.id_channel"
                    :selectedItems="selectedEntities"
                    :is-editable="isEditable"
                    :protocol-names="protocolNames"
                    :url-templates="urlTemplates"
                    :linear-protocol-ids="linearProtocolIds"
                    :nonlinear-protocol-ids="nonlinearProtocolIds"
                    :nonlinear-settings-allowed="nonlinearSettingsAllowed"
                    :content-source-is-virtual="contentSourceIsVirtual"
                    :linear-titles="linearTitles"
                    :nonlinear-titles="nonlinearTitles"
                    @delete-content-from-content-source="emitDeleteContentFromContentSource"
                    @delete-channel-from-content-source="emitDeleteChannelFromContentSource"
                    @submit="emitSubmit"
                    @input="select"
                    ref="content_source_content_row"
            ></content-source-content-row>
        </table>
        </div>
        <list-action-line
                :entities="entitiesPaginated"
                :selected-entities="[]"
                :limit="limit"
                :offset="offset"
                :total-count="totalCount"
                :multiple-action-options="multipleActionOptions"
                @run-multiple-action="runMultipleAction"
                @offset="offset = arguments[0]"
                @limit="onLimitChange(arguments[0])"
                ref="action_line"
        ></list-action-line>
    </section>
</template>

<script>
	import ContentSourceContentRow from "@/components/views/contentsources/content/ContentSourceContentRow"
	import ListActionLine from "@/components/common/ListActionLine"
	import {filterEntities} from "@/utils/helpers"
  import localTable from "@/components/mixins/local-table"

	export default {
		name: "ContentSourceContentList",
		components: {ListActionLine, ContentSourceContentRow},
		mixins: [localTable],
		props: {
			isEditable: Boolean,
			contentItems: {
				type: Array,
				default: () => {
					return []
				}
			},
			contentSourceId: [String, Number],
			urlTemplates: Array,
			protocolNames: {
				type: Object,
				default: () => {
					return {}
				}
			},
			linearProtocolIds: Array,
			nonlinearProtocolIds: Array,
			nonlinearSettingsAllowed: Object,
            contentSourceIsVirtual: Boolean,
		},
		data() {
			return {
				moduleName: 'contentSourceContents',
				search: '',
				offset: 0,
				limit: 10,
				selectedEntities: [],
        keepOffset: false
			}
		},
		created(ContentSourceService) {
			this.entityService = ContentSourceService
      this.loadAdditionalDefaults();
		},
        watch: {
			contentItems: {
				handler() {
					if (!this.keepOffset) {
						this.offset = 0
					} else {
						this.keepOffset = false
					}
                },
                deep: true,
            },
            search() {
				this.keepOffset = false
                this.offset = 0
            }
        },
		computed: {
			entitiesPaginated() {
				return this._.slice(this.entitiesFiltered, this.offset, this.offset + this.limit)
			},
			entitiesFiltered() {
				return filterEntities([...this.contentItems], ['channel_name', 'id_channel', 'id_epg'], this.search)
			},
			totalCount() {
				if (this.entitiesFiltered) {
					return this.entitiesFiltered.length
				} else {
					return 0
                }
			},
			linearTitles() {
				let titles = []
				this._.forEach(this.linearProtocolIds, (idProtocol) => {
					titles.push(this.protocolNames[idProtocol])
				})
				return titles
			},
      linearProtocols(){
        let protocols = {};
        for(const protocolId of this.linearProtocolIds){
          protocols[this.protocolNames[protocolId]] = protocolId
        }
        return protocols;
      },
			nonlinearTitles() {
				let titles = []
				this._.forEach(this.nonlinearProtocolIds, (idProtocol) => {
					titles.push(this.protocolNames[idProtocol])
				})
				return titles
			},
      nonlinearProtocols(){
        let protocols = {};
        for(const protocolId of this.nonlinearProtocolIds){
          protocols[this.protocolNames[protocolId]] = protocolId;
        }

        return protocols;
      },
      entities(){
        return Object.values(this.entitiesFiltered);
      },
      csvHeaders(){
       let headers = {
         'channel_name': {name: this.$gettext('Kanál')},
         'id_channel': {name: this.$gettext('ID')},
         'id_epg': {name: this.$gettext('ID EPG')},
       }
       for(const linearTitle of this.linearTitles){
         headers[linearTitle] = {name: linearTitle+' lineární', callback: (entity, index, columnName) => {
           return entity.linear_protocols_allowed_channel_ids[this.linearProtocols[columnName]] ? this.$gettext('Ano') : this.$gettext('Ne')}};
       }
      for(const nonlinearTitle of this.nonlinearTitles){
        headers[nonlinearTitle+'_'] = {name: nonlinearTitle+ ' nelineární', callback: (entity, index, columnName) => { return entity.nonlinear_content_settings.allowed_protocol_ids[this.nonlinearProtocols[columnName.slice(0, -1)]] ? this.$gettext('Ano') : this.$gettext('Ne')}};
      }
      headers.timeshift = {name: 'TimeShift', callback: entity=>{return entity.nonlinear_content_settings.has_timeshift ? this.$gettext('Ano') : this.$gettext('Ne')} };
      headers.catchup = {name: 'CatchUp', callback: entity=>{return entity.nonlinear_content_settings.has_catchup ? this.$gettext('Ano') : this.$gettext('Ne')} };
      headers.pvr = {name: 'PVR', callback: entity=>{return entity.nonlinear_content_settings.has_pvr ? this.$gettext('Ano') : this.$gettext('Ne')} };

      return headers;
      },
		},
		methods: {
			emitSubmit(data) {
				this.keepOffset = true
				this.$emit('submit', data)
			},
			emitDeleteContentFromContentSource(data) {
				this.keepOffset = true
				this.$emit('delete-content-from-content-source', data)
			},
			emitDeleteChannelFromContentSource(data) {
				this.keepOffset = true
				this.$emit('delete-channel-from-content-source', data)
			},
      onLimitChange(value){
        this.limit = value;
        this.saveFilterValues();
      },
      saveFilterValues() {
        this.setUserSetting('search', this.search)
        this.setUserSetting('limit', this.limit)
      },
      loadAdditionalDefaults() {
        const searchValue = this.getDefault('search');
        const limitValue = this.getDefault('limit');
        this.search = searchValue ? searchValue : '';
        this.limit = limitValue ? limitValue : 10;
      },
      getDefault(settingKey) {
        let data = {module: this.moduleName, key: settingKey}
        if (this.$store.getters.hasSetting(data)) {
          return this.$store.getters.getSetting(data)
        } else {
          return null
        }
      },
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/views/contentsources/content/ContentSourceContentList.vue